import React from "react";
import { Chip, useTheme } from "@mui/material";
import { RISK_LEVELS } from "../utils/constants";
import { getRiskChipSx } from "../utils/chipStyles";

const VendorRiskBadge = ({ level }) => {
  const theme = useTheme();
  const risk = level || RISK_LEVELS.UNSCORED;

  return (
    <Chip
      label={risk}
      variant="filled"
      size="small"
      sx={getRiskChipSx(theme, risk)}
    />
  );
};

export default VendorRiskBadge;
